module.exports = __webpack_public_path__ + "static/media/RecomendaSaoluis.47835a5b.jpg";